import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-performance-metrics-saved-dashboard',
  templateUrl: './client-performance-metrics-saved-dashboard.component.html',
  styleUrls: ['./client-performance-metrics-saved-dashboard.component.scss']
})
export class ClientPerformanceMetricsSavedDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
